/**
 * MUI ThemeProvider StorageManager backed by sessionStorage (per tab session).
 * @type {import('@mui/material/styles').StorageManager}
 */
function noop() {}

const muiSessionStorageManager = ({ key, storageWindow }) => {
  if (!storageWindow && typeof window !== 'undefined') {
    storageWindow = window;
  }
  return {
    get(defaultValue) {
      if (typeof window === 'undefined') {
        return undefined;
      }
      if (!storageWindow?.sessionStorage) {
        return defaultValue;
      }
      let value;
      try {
        value = storageWindow.sessionStorage.getItem(key);
      } catch {
        // unsupported
      }
      return value || defaultValue;
    },
    set: (value) => {
      if (storageWindow?.sessionStorage) {
        try {
          storageWindow.sessionStorage.setItem(key, value);
        } catch {
          // unsupported
        }
      }
    },
    subscribe: (handler) => {
      if (!storageWindow) {
        return noop;
      }
      const listener = (event) => {
        if (event.storageArea === storageWindow.sessionStorage && event.key === key) {
          handler(event.newValue);
        }
      };
      storageWindow.addEventListener('storage', listener);
      return () => {
        storageWindow.removeEventListener('storage', listener);
      };
    }
  };
};

export default muiSessionStorageManager;
